<app-youtube-navbar></app-youtube-navbar>

<!-- START: Main content -->
<div class="d-flex mt-4 gap-5">
  <!-- START: Subscriptions&Toolbar -->
  <div class="">
    <!-- START: Channels placeholder -->
    <div class="d-flex flex-column flex-shrink-1 gap-4">
      <span class="yt-channel-deformed placeholder"></span>
      <span class="yt-channel-deformed placeholder"></span>
      <span class="yt-channel-deformed placeholder"></span>
      <span class="yt-channel-deformed placeholder"></span>
      <span class="yt-channel-deformed placeholder"></span>
    </div>
    <!-- End: Channels placeholder -->
  </div>
  <!-- END: Subscriptions&Toolbar -->

  <!-- START: Content -->
  <div class="">
    <div class="yt-videos d-flex gap-3 flex-wrap">
      <!-- START: Real ad -->
      <div class="yt-video d-flex flex-column gap-2">
        <img *ngIf="creativeImage" class="yt-ad-image" [src]="creativeImage" alt="" />
        <div *ngIf="!creativeImage" class="yt-ad-image creative-missing">{{ missingDimensionLabel }}</div>
        <div class="yt-video-info">
          <h4 class="yt-title">{{ data.headlines[0] }}</h4>
          <div class="yt-meta">{{ data.descriptions[0] }}</div>
          <div class="yt-meta">
            <span class="yt-sponsored">Sponsored</span> • Valamar
          </div>
        </div>
      </div>
      <!-- END: Real ad -->

      <!-- START: Video placeholder -->
      <div class="yt-video d-flex flex-column gap-2">
        <img
          class="yt-ad-image"
          src="/assets/images/youtube-placeholder-video.png"
          alt=""
        />
        <div class="d-flex flex-row gap-2 align-items-start">
          <div class="yt-icon placeholder"></div>
          <div class="yt-video-info">
            <span class="yt-title placeholder">This is placeholder headline</span>
            <span class="yt-meta placeholder">Placeholder channel</span>
            <span class="yt-meta placeholder">1.2M views • 3 days ago</span>
          </div>
        </div>
      </div>
      <!-- END: Video placeholder -->

      <!-- START: Video placeholder -->
      <div class="yt-video d-flex flex-column gap-2">
        <img
          class="yt-ad-image"
          src="/assets/images/youtube-placeholder-video.png"
          alt=""
        />
        <div class="d-flex flex-row gap-2 align-items-start">
          <div class="yt-icon placeholder"></div>
          <div class="yt-video-info">
            <span class="yt-title placeholder">This is placeholder headline</span>
            <span class="yt-meta placeholder">Placeholder channel</span>
            <span class="yt-meta placeholder">1.2M views • 3 days ago</span>
          </div>
        </div>
      </div>
      <!-- END: Video placeholder -->

      <!-- START: Video placeholder -->
      <div class="yt-video d-flex flex-column gap-2">
        <img
          class="yt-ad-image"
          src="/assets/images/youtube-placeholder-video.png"
          alt=""
        />
        <div class="d-flex flex-row gap-2 align-items-start">
          <div class="yt-icon placeholder"></div>
          <div class="yt-video-info">
            <span class="yt-title placeholder">This is placeholder headline</span>
            <span class="yt-meta placeholder">Placeholder channel</span>
            <span class="yt-meta placeholder">1.2M views • 3 days ago</span>
          </div>
        </div>
      </div>
      <!-- END: Video placeholder -->
    </div>
  </div>
  <!-- End: Content -->
</div>
<!-- END: Main content -->
